import { useState, useEffect } from 'react';
import bem from '../../../../utils/bem';
import Input from '../Input';
import useWindowWidth from '../../../../hooks/useWindowWidth';

const Checkboxes = ({ settings, onChange, setState }) => {
  const {
    name,
    state,
    options,
    wrapperClasses = [],
    label,
    viewAllButton = false,
    forceTabletViewAll = false,
    viewAllButtonText = Drupal.t('View All'),
    hidden = false,
  } = settings || {};
  const baseClass = 'form-item';
  const { width } = useWindowWidth();
  const [viewAllEnabled, setViewAllState] = useState(viewAllButton);
  const isTablet = width > 767 && width < 1280;

  useEffect(() => {
    options.every((option) => {
      if (!option.checked) {
        return true;
      }
      setState((prev) =>
        prev[name].includes(option.value)
          ? prev
          : {
              ...prev,
              [name]: [...(prev[`${name}`] || []), option.value],
            },
      );
      return true;
    });
  }, []);

  if (!options || !options.length || hidden) {
    return '';
  }

  const renderOptions = options.map((option, index) => {
    if (viewAllEnabled && index > 4 && !(isTablet && !forceTabletViewAll)) {
      return '';
    }

    const { value, label: optionLabel, disabled = false } = option;
    const isChecked =
      state &&
      state[name] &&
      state[name].find((el) => {
        if (el && el !== 'undefined') {
          return el.includes(value);
        }
        return [];
      });
    const id = `${name}-${value}`.replaceAll(' ', '-');
    return (
      <div className={`form-item ${disabled ? 'disabled' : ''}`} key={id}>
        <Input
          id={id}
          value={value}
          name={id}
          onChange={onChange}
          checked={isChecked}
          className={'form-checkbox'}
          disabled={disabled}
          data-name={name}
          children={optionLabel}
          extraLabel={'option'}
          data-label={optionLabel}
        />
      </div>
    );
  });

  return (
    <div className={bem(baseClass, ['checkboxes'], '', wrapperClasses)}>
      {label && <h6>{label}</h6>}
      {renderOptions}
      {viewAllEnabled &&
        options.length > 5 &&
        !(isTablet && !forceTabletViewAll) && (
          <div>
            <button
              className="btn-link view-all-link"
              onClick={() => setViewAllState(false)}
            >
              {viewAllButtonText}
            </button>
          </div>
        )}
    </div>
  );
};

export default Checkboxes;
